import { useTableColumnsTrazabilidad } from "@/shared";
import { SampleTable, TabTextLabel } from "@/shared/components/ui";
import { Contrato } from "@/shared/interfaces";
import { ITrazabilidad } from "@/shared/interfaces/erp/global/trazabilidad.interface";
import { Grid } from "@mui/material";

export type TrazabilidadLogFormTabProps = {
  contract: Contrato;
};

export default function TrazabilidadLogFormTab({
  contract
}: TrazabilidadLogFormTabProps) {

  const { columnBase } = useTableColumnsTrazabilidad()
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TabTextLabel
            text="TRAZABILIDAD - LOG"
          />
        </Grid>

        <Grid item xs={12}>

          <SampleTable<ITrazabilidad>
            columns={columnBase}
            data={contract.cliente_data?.trazo_venta_data || []}
          />

        </Grid>


      </Grid>
    </>
  );

}